export const isProjectCompatible = (
    sceneVersion: number,
    projectVersion: number | undefined
) => {
    if (!projectVersion && sceneVersion === 0) {
        return true; // Legacy project, should be compatible if the scene never got breaking changes
    } else {
        return sceneVersion === projectVersion;
    }
};